import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getDictionaryUnitMap } from '../../../../api/dictionary/queries/getDictionaryUnitMap';
import { IDictionaryUnitMap } from '../../../../interfaces/Dictionary.interfaces';

export const useGetDictionaryUnitMapQuery = () => {
  return useQuery<IDictionaryUnitMap, AxiosError>(['dictionary_unit_map'], getDictionaryUnitMap);
};
